import React, { useState, useEffect } from 'react';

const StandaloneInput = ({ 
  type = "text", 
  value, 
  onChange, 
  placeholder, 
  className,
  ...props 
}) => {
  const [internalValue, setInternalValue] = useState(value || '');

  // Only update internal value when external value changes significantly
  useEffect(() => {
    if (value !== internalValue) {
      setInternalValue(value || '');
    }
  }, [value, internalValue]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <input
      type={type}
      value={internalValue}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      {...props}
    />
  );
};

export default StandaloneInput; 